import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  class: "spinner-grow text-danger",
  style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
  role: "status"
}
const _hoisted_3 = { class: "visually-hidden" }
const _hoisted_4 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing",
  id: "back"
}
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 flex-wrap gap-10" }
const _hoisted_6 = { class: "mb-0 fw-bold text-black" }
const _hoisted_7 = {
  key: 0,
  class: "mb-0 mt-5 fs-13 text-body-tertiary"
}
const _hoisted_8 = { class: "double-entries-actions" }
const _hoisted_9 = ["disabled", "title", "aria-label"]
const _hoisted_10 = { class: "double-entries-search" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = ["aria-label", "title"]
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = ["title", "aria-label"]
const _hoisted_15 = {
  key: 0,
  class: "filter-badge"
}
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_17 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_21 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_22 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_23 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_24 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_25 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_26 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}
const _hoisted_27 = { class: "visually-hidden" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis ps-0 fs-md-15 fs-lg-16" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_30 = ["title", "onClick"]
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-black-emphasis fs-md-15 fs-lg-16" }
const _hoisted_32 = ["title"]
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-black-emphasis fs-md-15 fs-lg-16" }
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "shadow-none lh-1 text-end" }
const _hoisted_36 = { class: "fs-6 fw-bold text-black" }
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_39 = { class: "badge text-outline-primary" }
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-end pe-0" }
const _hoisted_42 = ["title", "aria-label", "onClick"]
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  colspan: "9",
  class: "text-center text-body-tertiary py-25"
}
const _hoisted_45 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_46 = { class: "mb-0 text-paragraph" }
const _hoisted_47 = { class: "fw-bold" }
const _hoisted_48 = { class: "mt-15 mt-md-0" }
const _hoisted_49 = { class: "pagination mb-0" }
const _hoisted_50 = {
  key: 0,
  class: "page-item"
}
const _hoisted_51 = {
  key: 0,
  class: "page-link"
}
const _hoisted_52 = {
  key: 1,
  class: "page-link active",
  href: "javascript:void(0);"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 1,
  class: "page-item"
}
const _hoisted_55 = {
  class: "modal fade",
  id: "doubleEntriesFiltersModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_56 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_57 = { class: "modal-content" }
const _hoisted_58 = { class: "modal-header" }
const _hoisted_59 = { class: "modal-title fs-5" }
const _hoisted_60 = { class: "modal-body" }
const _hoisted_61 = { class: "row g-3" }
const _hoisted_62 = { class: "col-12 col-md-6" }
const _hoisted_63 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_64 = { class: "col-12 col-md-6" }
const _hoisted_65 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_66 = { class: "col-12 col-md-6" }
const _hoisted_67 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_68 = { class: "col-12 col-md-6" }
const _hoisted_69 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_70 = { class: "col-12 col-md-6" }
const _hoisted_71 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_72 = { value: "" }
const _hoisted_73 = { value: "REAL" }
const _hoisted_74 = { value: "VIRTUAL" }
const _hoisted_75 = { class: "col-12 col-md-6" }
const _hoisted_76 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_77 = { class: "col-12 col-md-6" }
const _hoisted_78 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_79 = { class: "col-12 col-md-6" }
const _hoisted_80 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_81 = { class: "col-12 col-md-4" }
const _hoisted_82 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_83 = { class: "col-6 col-md-4" }
const _hoisted_84 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_85 = { class: "col-6 col-md-4" }
const _hoisted_86 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_87 = { class: "col-6" }
const _hoisted_88 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_89 = { value: "DESC" }
const _hoisted_90 = { value: "ASC" }
const _hoisted_91 = { class: "col-6" }
const _hoisted_92 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_93 = { class: "modal-footer" }
const _hoisted_94 = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_95 = ["disabled"]
const _hoisted_96 = { style: {"color":"#FFF"} }
const _hoisted_97 = {
  class: "modal fade",
  id: "entryDetailModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_98 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_99 = { class: "modal-content" }
const _hoisted_100 = { class: "modal-header" }
const _hoisted_101 = { class: "modal-title fs-5" }
const _hoisted_102 = {
  key: 0,
  class: "modal-tabs"
}
const _hoisted_103 = { class: "modal-body" }
const _hoisted_104 = {
  key: 0,
  class: "detail-state"
}
const _hoisted_105 = {
  class: "spinner-border text-danger",
  role: "status"
}
const _hoisted_106 = { class: "visually-hidden" }
const _hoisted_107 = {
  key: 1,
  class: "detail-state flex-column gap-10"
}
const _hoisted_108 = { class: "mb-0 text-body-tertiary" }
const _hoisted_109 = {
  key: 2,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_110 = { class: "row g-3" }
const _hoisted_111 = {
  key: 0,
  class: "col-12 col-md-3"
}
const _hoisted_112 = {
  key: 1,
  class: "col-12 col-md-3"
}
const _hoisted_113 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_114 = ["value"]
const _hoisted_115 = {
  key: 2,
  class: "col-12 col-md-3"
}
const _hoisted_116 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_117 = ["value"]
const _hoisted_118 = {
  key: 3,
  class: "col-12 col-md-3"
}
const _hoisted_119 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_120 = {
  key: 4,
  class: "col-12 col-md-3"
}
const _hoisted_121 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_122 = ["value"]
const _hoisted_123 = {
  key: 5,
  class: "col-12 col-md-3"
}
const _hoisted_124 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_125 = ["value"]
const _hoisted_126 = {
  key: 6,
  class: "col-12 col-md-3"
}
const _hoisted_127 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_128 = {
  key: 7,
  class: "col-12 col-md-3"
}
const _hoisted_129 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_130 = {
  key: 8,
  class: "col-12"
}
const _hoisted_131 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_132 = ["value"]
const _hoisted_133 = { class: "detail-section-title" }
const _hoisted_134 = { class: "ledger-wrapper" }
const _hoisted_135 = { class: "ledger-table" }
const _hoisted_136 = { class: "ledger-account-cell" }
const _hoisted_137 = { class: "ledger-account-name" }
const _hoisted_138 = {
  key: 0,
  class: "ledger-account-code"
}
const _hoisted_139 = { class: "ledger-code-text" }
const _hoisted_140 = ["onClick"]
const _hoisted_141 = { class: "ledger-amount-cell" }
const _hoisted_142 = { class: "ledger-amount-value" }
const _hoisted_143 = { class: "ledger-amount-currency" }
const _hoisted_144 = { class: "ledger-account-cell" }
const _hoisted_145 = { class: "ledger-account-name" }
const _hoisted_146 = {
  key: 0,
  class: "ledger-account-code"
}
const _hoisted_147 = { class: "ledger-code-text" }
const _hoisted_148 = ["onClick"]
const _hoisted_149 = { class: "ledger-amount-cell" }
const _hoisted_150 = { class: "ledger-amount-value" }
const _hoisted_151 = { class: "ledger-amount-currency" }
const _hoisted_152 = { key: 0 }
const _hoisted_153 = { key: 0 }
const _hoisted_154 = { class: "ledger-total-cell" }
const _hoisted_155 = { class: "ledger-total-value" }
const _hoisted_156 = { class: "ledger-amount-currency" }
const _hoisted_157 = { class: "ledger-total-cell" }
const _hoisted_158 = { class: "ledger-total-value" }
const _hoisted_159 = { class: "ledger-amount-currency" }
const _hoisted_160 = { class: "detail-section-title" }
const _hoisted_161 = { class: "row g-3" }
const _hoisted_162 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_163 = ["value"]
const _hoisted_164 = { class: "detail-section-title" }
const _hoisted_165 = { class: "row g-3" }
const _hoisted_166 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_167 = ["value"]
const _hoisted_168 = { class: "detail-section-title" }
const _hoisted_169 = { class: "row g-3" }
const _hoisted_170 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_171 = ["value"]
const _hoisted_172 = { class: "detail-section-title" }
const _hoisted_173 = { class: "row g-3" }
const _hoisted_174 = {
  key: 0,
  class: "col-12 col-md-6"
}
const _hoisted_175 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_176 = ["value"]
const _hoisted_177 = {
  key: 1,
  class: "col-12 col-md-6"
}
const _hoisted_178 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_179 = ["value"]
const _hoisted_180 = {
  key: 2,
  class: "col-12 col-md-6"
}
const _hoisted_181 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_182 = ["value"]

import { ref, reactive, computed, onMounted, inject } from "vue";
import { useI18n } from "vue-i18n";
import axios from 'axios';
import { Modal } from 'bootstrap';
import { current_permissions } from '../../../utils/permission';
import router from '../../../router/index';
import { showToast, checkSessionValidate } from "@/utils/function";

interface DoubleEntry {
  code: string;
  description: string;
  amount: number;
  currency: string;
  entryType: string;
  adjustmentType: string;
  createdAt: string;
  entity: string;
  entityCode: string;
}

interface AccountLabel {
  label: string;
  raw: string;
}

interface EntryRow extends DoubleEntry {
  debit: AccountLabel;
  credit: AccountLabel;
}

interface LedgerAccount {
  code: string;
  name: string;
  type: string;
  merchantAccountType: string | null;
  providerBalanceType: string | null;
}

interface LedgerEntry {
  amount: number;
  operationDirection: 'DEBIT' | 'CREDIT' | string;
  ledgerAccount: LedgerAccount;
}

interface DoubleEntryTransaction {
  checkoutId: string | null;
  payoutId: string | null;
  intBulkId: string | null;
  payoutType: number | null;
  amount: number | null;
  bulkTotalAmount: number | null;
  totalFees: number | null;
  imoneyFees: number | null;
  intOperatorBulkId: string | null;
  operatorFees: number | null;
  code: string | null;
  bankTransfertId: string | null;
  transactionType: number | null;
  bankTransfertType: string | number | null;
}

interface DoubleEntryDetail {
  code: string;
  description: string;
  amount: number;
  currency: string;
  entryType: string;
  adjustmentType: string;
  integrityHash: string | null;
  previousHash: string | null;
  externalReference: string | null;
  transaction: DoubleEntryTransaction | null;
  topup: Record<string, unknown> | null;
  repayment: Record<string, unknown> | null;
  ledgerEntries: LedgerEntry[];
  createdAt: string;
  entity: string;
  entityCode: string;
}

interface DetailField {
  key: string;
  label: string;
  value: string | number;
  copyable?: boolean;
}

interface LedgerTableRow {
  debitAccount: string;
  debitCode: string;
  debitAmount: number;
  creditAccount: string;
  creditCode: string;
  creditAmount: number;
  currency: string;
  operation: string;
}

interface Filters {
  description: string;
  code: string;
  externalReference: string;
  entityType: string;
  entityCode: string;
  entryType: string;
  currency: string;
  amount: string;
  minAmount: string;
  maxAmount: string;
  dateFrom: string;
  dateTo: string;
  ordre: 'ASC' | 'DESC';
  count: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DoubleWriteContent',
  setup(__props) {

const { t } = useI18n();

const backApi = inject('back');
const token = localStorage.getItem('login_token');

const doubleEntriesUrl = backApi + '/secure/ledger/double-entries';

const loader = ref(false);
const tableLoading = ref(false);

const entries = ref(new Array<DoubleEntry>());
const page = ref(1);
const total = ref(0);
const numPages = ref(1);

// ═══ Utilitaires (déclarés avant les computed qui les utilisent) ═══
function hasValue(value: any): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === '—' || trimmed === 'null' || trimmed === 'undefined') return false;
  }
  if (typeof value === 'number' && isNaN(value)) return false;
  return true;
}

function formatNumber(value: number): string {
  return Number(value || 0).toLocaleString('fr-FR').replace(/\u202f/g, ' ').replace(/\u00a0/g, ' ');
}

function formatAmount(value: any): string {
  const num = Number(value ?? 0);
  if (isNaN(num)) return '0';
  return num
    .toLocaleString('fr-FR', { maximumFractionDigits: 4 })
    .replace(/\u202f/g, ' ')
    .replace(/\u00a0/g, ' ');
}

function formatDateTimeFr(value: string | null | undefined, withSeconds = false) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const base = `${day}/${month}/${year} ${hours}:${minutes}`;
  return withSeconds ? `${base}:${String(d.getSeconds()).padStart(2, '0')}` : base;
}

function shortRef(code: string): string {
  if (!code) return '';
  return code.length > 8 ? `${code.slice(0, 8)}…` : code;
}

function showModal(id: string) {
  const el = document.getElementById(id);
  if (el) Modal.getOrCreateInstance(el).show();
}
function hideModal(id: string) {
  const el = document.getElementById(id);
  if (el) Modal.getInstance(el)?.hide();
}

// ═══ Filtres ═══
const defaultFilters = (): Filters => ({
  description: '',
  code: '',
  externalReference: '',
  entityType: '',
  entityCode: '',
  entryType: '',
  currency: '',
  amount: '',
  minAmount: '',
  maxAmount: '',
  dateFrom: '',
  dateTo: '',
  ordre: 'DESC',
  count: 50,
});

const searchQuery = ref('');
const filters = reactive<Filters>(defaultFilters());
const appliedFilters = ref<Filters>(defaultFilters());

// Le badge de filtre exclut la description et le code car ils sont gérés
// par la barre de recherche principale (mais on les garde quand même
// comptés s'ils sont saisis dans le modal des filtres)
const FILTER_KEYS = [
  'description', 'code', 'externalReference', 'entityType', 'entityCode',
  'entryType', 'currency', 'amount', 'minAmount', 'maxAmount', 'dateFrom', 'dateTo',
] as const;

const activeFiltersCount = computed(
  () => FILTER_KEYS.filter((key) => String(appliedFilters.value[key]).trim() !== '').length
);

function buildParams(pageArg: number) {
  const f = appliedFilters.value;
  const params: Record<string, string | number> = {
    page: pageArg,
    count: f.count,
    ordre: f.ordre,
  };
  FILTER_KEYS.forEach((key) => {
    const value = String(f[key]).trim();
    if (value !== '') params[key] = key === 'currency' ? value.toUpperCase() : value;
  });
  return params;
}

// ═══ Recherche principale : code OU description ═══
// Détecte si la saisie est un UUID (recherche par code) ou du texte libre
// (recherche par description). Le backend reçoit le paramètre approprié.
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function searchDescription() {
  const q = searchQuery.value.trim();

  if (!q) {
    // Champ vide : on nettoie les deux champs et on recharge
    appliedFilters.value = {
      ...appliedFilters.value,
      code: '',
      description: '',
    };
    fetchEntries(1);
    return;
  }

  const looksLikeUuid = UUID_REGEX.test(q);

  appliedFilters.value = {
    ...appliedFilters.value,
    code: looksLikeUuid ? q : '',
    description: looksLikeUuid ? '' : q,
  };
  fetchEntries(1);
}

// Efface la barre de recherche et relance la liste complète
function clearSearch() {
  searchQuery.value = '';
  appliedFilters.value = {
    ...appliedFilters.value,
    code: '',
    description: '',
  };
  fetchEntries(1);
}

// Refresh : vide aussi la barre de recherche
function refreshAndClear() {
  searchQuery.value = '';
  appliedFilters.value = defaultFilters();
  Object.assign(filters, defaultFilters());
  fetchEntries(1);
}

function openFiltersModal() {
  Object.assign(filters, appliedFilters.value);
  showModal('doubleEntriesFiltersModal');
}

function applyFilters() {
  if (filters.minAmount !== '' && filters.maxAmount !== '' && Number(filters.minAmount) > Number(filters.maxAmount)) {
    showToast(t('doubleEntries.error_amount_range'), "red");
    return;
  }
  if (filters.dateFrom && filters.dateTo && filters.dateFrom > filters.dateTo) {
    showToast(t('doubleEntries.error_date_range'), "red");
    return;
  }
  appliedFilters.value = { ...filters };
  searchQuery.value = filters.code || filters.description || '';
  hideModal('doubleEntriesFiltersModal');
  fetchEntries(1);
}

function resetFilters() {
  Object.assign(filters, defaultFilters());
  searchQuery.value = '';
  appliedFilters.value = defaultFilters();
  hideModal('doubleEntriesFiltersModal');
  fetchEntries(1);
}

// ═══ Parsing de la description (pour le tableau principal) ═══
const TRANSFER_REGEX = /\sdu\s+(.+?)\s+vers\s+(?:le|la|les|l')\s*(.+)$/i;
const SMALL_WORDS = new Set(['de', 'du', 'des', 'la', 'le', 'les', 'en', 'et', 'by']);

function prettifyAccount(raw: string): string {
  const cleaned = raw.replace(/^COMPTE\s+(DE\s+|DU\s+|D')?/i, '').trim();
  if (!cleaned) return raw;

  return cleaned
    .split(/\s+/)
    .map((word, i) => {
      if (word === '-') return word;
      const lower = word.toLowerCase();
      if (i > 0 && SMALL_WORDS.has(lower)) return lower;
      if (word.length <= 2) return word.toUpperCase();
      return word
        .split('-')
        .map((part) => (part.length <= 1 ? part.toUpperCase() : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()))
        .join('-');
    })
    .join(' ');
}

function parseAccounts(description: string): { debit: AccountLabel; credit: AccountLabel } {
  const empty: AccountLabel = { label: '—', raw: description ?? '' };
  const match = (description ?? '').match(TRANSFER_REGEX);
  if (!match) return { debit: empty, credit: empty };

  const debitRaw = match[1].trim();
  const creditRaw = match[2].trim();
  return {
    debit: { label: prettifyAccount(debitRaw), raw: debitRaw },
    credit: { label: prettifyAccount(creditRaw), raw: creditRaw },
  };
}

const rows = computed<EntryRow[]>(() =>
  entries.value.map((entry) => {
    const { debit, credit } = parseAccounts(entry.description);
    return { ...entry, debit, credit };
  })
);

// ═══ Modal Détail ═══
const detail = ref<DoubleEntryDetail | null>(null);
const detailLoading = ref(false);
const detailError = ref(false);
const currentDetailCode = ref('');

const activeDetailTab = ref<'main' | 'advanced'>('main');

function openDetail(row: EntryRow) {
  showModal('entryDetailModal');
  activeDetailTab.value = 'main';
  fetchDetail(row.code);
}

async function fetchDetail(code: string) {
  if (!code) return;

  currentDetailCode.value = code;
  detail.value = null;
  detailError.value = false;
  detailLoading.value = true;

  try {
    const response = await axios.get(`${doubleEntriesUrl}/${encodeURIComponent(code)}/show`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    if (currentDetailCode.value !== code) return;
    detail.value = (response.data?.data ?? response.data) as DoubleEntryDetail;
  } catch (error: any) {
    if (currentDetailCode.value !== code) return;
    detailError.value = true;
    if (error?.response?.status === 401) hideModal('entryDetailModal');
    handleAxiosError(error, t('doubleEntries.error_loading_detail'));
  } finally {
    if (currentDetailCode.value === code) detailLoading.value = false;
  }
}

// ── Transaction associée (filtrée directement dans la computed) ──
const transactionFields = computed<DetailField[]>(() => {
  const tx = detail.value?.transaction;
  if (!tx) return [];

  const defs: { key: keyof DoubleEntryTransaction; label: string; kind?: 'amount' }[] = [
    { key: 'code', label: t('doubleEntries.tx_code') },
    { key: 'payoutId', label: t('doubleEntries.tx_payout_id') },
    { key: 'checkoutId', label: t('doubleEntries.tx_checkout_id') },
    { key: 'intBulkId', label: t('doubleEntries.tx_int_bulk_id') },
    { key: 'intOperatorBulkId', label: t('doubleEntries.tx_int_operator_bulk_id') },
    { key: 'bankTransfertId', label: t('doubleEntries.tx_bank_transfert_id') },
    { key: 'transactionType', label: t('doubleEntries.tx_transaction_type') },
    { key: 'payoutType', label: t('doubleEntries.tx_payout_type') },
    { key: 'bankTransfertType', label: t('doubleEntries.tx_bank_transfert_type') },
    { key: 'amount', label: t('doubleEntries.tx_amount'), kind: 'amount' },
    { key: 'bulkTotalAmount', label: t('doubleEntries.tx_bulk_total_amount'), kind: 'amount' },
    { key: 'totalFees', label: t('doubleEntries.tx_total_fees'), kind: 'amount' },
    { key: 'imoneyFees', label: t('doubleEntries.tx_imoney_fees'), kind: 'amount' },
    { key: 'operatorFees', label: t('doubleEntries.tx_operator_fees'), kind: 'amount' },
  ];

  return defs
    .filter(({ key }) => hasValue(tx[key]))
    .map(({ key, label, kind }) => {
      const raw = tx[key];
      return {
        key,
        label,
        value: kind === 'amount'
          ? `${formatAmount(raw)} ${detail.value?.currency ?? ''}`.trim()
          : (raw as string | number),
        copyable: false,
      };
    });
});

// ── Topup / Remboursement ──
function humanizeKey(key: string): string {
  const spaced = key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_-]+/g, ' ').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

function genericFields(obj: Record<string, unknown> | null | undefined): DetailField[] {
  if (!obj || typeof obj !== 'object') return [];
  return Object.entries(obj)
    .filter(([, value]) => hasValue(value))
    .map(([key, value]) => ({
      key,
      label: humanizeKey(key),
      value: typeof value === 'object' ? JSON.stringify(value) : (value as string | number),
    }));
}

const topupFields = computed(() => genericFields(detail.value?.topup));
const repaymentFields = computed(() => genericFields(detail.value?.repayment));

// ── Tableau des mouvements comptables ──
// On affiche le nom COMPLET du compte tel que fourni par l'API
// (ledgerAccount.name), sans passer par prettifyAccount.
const ledgerTableRows = computed<LedgerTableRow[]>(() => {
  const ledgerEntries = detail.value?.ledgerEntries ?? [];
  const debits = ledgerEntries.filter((e) => (e.operationDirection ?? '').toUpperCase() === 'DEBIT');
  const credits = ledgerEntries.filter((e) => (e.operationDirection ?? '').toUpperCase() === 'CREDIT');
  const rowCount = Math.max(debits.length, credits.length);
  const currency = detail.value?.currency ?? '';
  const operation = detail.value?.entity ?? '';

  return Array.from({ length: rowCount }, (_, i) => {
    const d = debits[i];
    const c = credits[i];
    return {
      debitAccount: d ? (d.ledgerAccount?.name || '—') : '—',
      debitCode: d?.ledgerAccount?.code ?? '',
      debitAmount: d ? d.amount : 0,
      creditAccount: c ? (c.ledgerAccount?.name || '—') : '—',
      creditCode: c?.ledgerAccount?.code ?? '',
      creditAmount: c ? c.amount : 0,
      currency,
      operation,
    };
  });
});

const totalDebit = computed(() => ledgerTableRows.value.reduce((sum, row) => sum + row.debitAmount, 0));
const totalCredit = computed(() => ledgerTableRows.value.reduce((sum, row) => sum + row.creditAmount, 0));

// ═══ Badges ═══
function entryTypeLabel(type: string): string {
  switch ((type ?? '').toLowerCase()) {
    case 'real': return t('doubleEntries.real');
    case 'virtual': return t('doubleEntries.virtual');
    default: return type ?? '';
  }
}
function entryTypeClass(type: string): string {
  switch ((type ?? '').toLowerCase()) {
    case 'real': return 'text-outline-success';
    case 'virtual': return 'text-outline-info';
    default: return 'text-outline-primary';
  }
}

function adjustmentLabel(type: string): string {
  if ((type ?? '').toLowerCase() === 'normal') return t('doubleEntries.normal');
  return type ? type.charAt(0).toUpperCase() + type.slice(1) : '';
}
function adjustmentClass(type: string): string {
  return (type ?? '').toLowerCase() === 'normal' ? 'text-outline-primary' : 'text-outline-danger';
}

// ═══ Copie ═══
async function copyText(value: string) {
  try {
    await navigator.clipboard.writeText(value);
    showToast(t('doubleEntries.copied'), "green");
  } catch {
    showToast(t('doubleEntries.error_occurred'), "red");
  }
}

// ═══ Pagination ═══
const visiblePages = computed<(number | string)[]>(() => {
  const last = numPages.value;
  const current = page.value;

  if (last <= 7) return Array.from({ length: last }, (_, i) => i + 1);

  const pages: (number | string)[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(last - 1, current + 1);

  if (start > 2) pages.push('…');
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < last - 1) pages.push('…');
  pages.push(last);

  return pages;
});

function goToPage(target: number) {
  if (target === page.value || target < 1 || target > numPages.value || tableLoading.value) return;
  fetchEntries(target);
}

// ═══ Appel API ═══
function handleAxiosError(error: any, fallback = t('doubleEntries.error_occurred')) {
  if (error.response) {
    if (error.response.status === 401) {
      router.push('/');
    } else {
      showToast(error.response.data?.message ?? fallback, "red");
    }
  } else {
    showToast(fallback, "red");
  }
}

async function fetchEntries(pageArg = 1, initial = false) {
  if (initial) {
    loader.value = false;
  } else {
    tableLoading.value = true;
  }

  try {
    const response = await axios.get(doubleEntriesUrl, {
      params: buildParams(pageArg),
      headers: { Authorization: `Bearer ${token}` }
    });

    entries.value = response.data.data ?? [];

    const pagination = response.data.pagination ?? {};
    page.value = Number(pagination.currentPage ?? pageArg);
    total.value = Number(pagination.total ?? entries.value.length);
    numPages.value = Number(pagination.numPages ?? 1);
  } catch (error) {
    handleAxiosError(error, t('doubleEntries.error_loading'));
  } finally {
    loader.value = true;
    tableLoading.value = false;
  }
}

onMounted(() => {
  checkSessionValidate(1);
  fetchEntries(1, true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('doubleEntries.loading')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t('doubleEntries.title')), 1),
              (total.value > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('doubleEntries.total_entries', { count: formatNumber(total.value) })), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "action-icon-btn refresh-btn",
                type: "button",
                disabled: tableLoading.value,
                title: _ctx.$t('doubleEntries.refresh'),
                "aria-label": _ctx.$t('doubleEntries.refresh'),
                onClick: refreshAndClear
              }, [...(_cache[23] || (_cache[23] = [
                _createElementVNode("i", { class: "flaticon-refresh" }, null, -1)
              ]))], 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                  type: "text",
                  class: "double-entries-search-input",
                  placeholder: _ctx.$t('doubleEntries.search_placeholder'),
                  onKeyup: _withKeys(searchDescription, ["enter"])
                }, null, 40, _hoisted_11), [
                  [_vModelText, searchQuery.value]
                ]),
                (searchQuery.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "double-entries-clear-btn",
                      "aria-label": _ctx.$t('doubleEntries.clear_search'),
                      title: _ctx.$t('doubleEntries.clear_search'),
                      onClick: clearSearch
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("i", { class: "flaticon-cancel" }, null, -1)
                    ]))], 8, _hoisted_12))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "double-entries-search-btn",
                      "aria-label": _ctx.$t('doubleEntries.search_placeholder'),
                      onClick: searchDescription
                    }, [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("i", { class: "flaticon-search-interface-symbol" }, null, -1)
                    ]))], 8, _hoisted_13))
              ]),
              _createElementVNode("button", {
                class: "action-icon-btn filter-btn",
                type: "button",
                title: _ctx.$t('doubleEntries.filters'),
                "aria-label": _ctx.$t('doubleEntries.filters'),
                onClick: openFiltersModal
              }, [
                _cache[26] || (_cache[26] = _createElementVNode("svg", {
                  width: "19",
                  height: "19",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
                ], -1)),
                (activeFiltersCount.value > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(activeFiltersCount.value), 1))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_14)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(["table-responsive", { 'table-loading': tableLoading.value }])
            }, [
              _createElementVNode("table", _hoisted_17, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('doubleEntries.date')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('doubleEntries.reference')), 1),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('doubleEntries.debit')), 1),
                    _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('doubleEntries.credit')), 1),
                    _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('doubleEntries.amount')) + " (XOF)", 1),
                    _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('doubleEntries.entry_type')), 1),
                    _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('doubleEntries.entity')), 1),
                    _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('doubleEntries.status')), 1),
                    _createElementVNode("th", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('doubleEntries.actions')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.code
                    }, [
                      _createElementVNode("td", _hoisted_28, _toDisplayString(formatDateTimeFr(row.createdAt)), 1),
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ref-btn",
                          title: `${row.code}\n${_ctx.$t('doubleEntries.copy_reference')}`,
                          onClick: ($event: any) => (copyText(row.code))
                        }, _toDisplayString(shortRef(row.code)), 9, _hoisted_30)
                      ]),
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("span", {
                          title: row.debit.raw
                        }, _toDisplayString(row.debit.label), 9, _hoisted_32)
                      ]),
                      _createElementVNode("td", _hoisted_33, [
                        _createElementVNode("span", {
                          title: row.credit.raw
                        }, _toDisplayString(row.credit.label), 9, _hoisted_34)
                      ]),
                      _createElementVNode("td", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(formatAmount(row.amount)), 1)
                      ]),
                      _createElementVNode("td", _hoisted_37, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", entryTypeClass(row.entryType)])
                        }, _toDisplayString(entryTypeLabel(row.entryType)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_38, [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(row.entity), 1)
                      ]),
                      _createElementVNode("td", _hoisted_40, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", adjustmentClass(row.adjustmentType)])
                        }, _toDisplayString(adjustmentLabel(row.adjustmentType)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_41, [
                        (_unref(current_permissions)('show_double_entry'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "dot-btn lh-1 position-relative bg-transparent border-0 shadow-none p-0 transition d-inline-flex align-items-center",
                              title: _ctx.$t('doubleEntries.view_detail'),
                              "aria-label": _ctx.$t('doubleEntries.view_detail'),
                              onClick: ($event: any) => (openDetail(row))
                            }, [...(_cache[27] || (_cache[27] = [
                              _createElementVNode("i", { class: "flaticon-view fs-16" }, null, -1)
                            ]))], 8, _hoisted_42))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128)),
                  (!rows.value.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                        _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.$t('doubleEntries.no_entries')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2),
            (total.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("p", _hoisted_46, [
                    _createTextVNode(_toDisplayString(_ctx.$t('doubleEntries.showing', { count: entries.value.length })) + " ", 1),
                    _createElementVNode("span", _hoisted_47, _toDisplayString(formatNumber(total.value)), 1)
                  ]),
                  _createElementVNode("nav", _hoisted_48, [
                    _createElementVNode("ul", _hoisted_49, [
                      (page.value > 1)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_50, [
                            _createElementVNode("a", {
                              class: "page-link",
                              href: "javascript:void(0);",
                              "aria-label": "Previous",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(page.value - 1)))
                            }, [...(_cache[28] || (_cache[28] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, idx) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `${p}-${idx}`,
                          class: _normalizeClass(["page-item", { disabled: p === '…' }])
                        }, [
                          (p === '…')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, "…"))
                            : (p === page.value)
                              ? (_openBlock(), _createElementBlock("a", _hoisted_52, _toDisplayString(p), 1))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  class: "page-link",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (goToPage(p as number))
                                }, _toDisplayString(p), 9, _hoisted_53))
                        ], 2))
                      }), 128)),
                      (page.value < numPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                            _createElementVNode("a", {
                              class: "page-link",
                              href: "javascript:void(0);",
                              "aria-label": "Next",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage(page.value + 1)))
                            }, [...(_cache[29] || (_cache[29] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(applyFilters, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("h1", _hoisted_59, _toDisplayString(_ctx.$t('doubleEntries.filters_title')), 1),
              _cache[30] || (_cache[30] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('doubleEntries.reference')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.code) = $event)),
                    type: "text",
                    class: "form-control shadow-none fw-medium text-black fs-md-15"
                  }, null, 512), [
                    [_vModelText, filters.code]
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('doubleEntries.description')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.description) = $event)),
                    type: "text",
                    class: "form-control shadow-none fw-medium text-black fs-md-15"
                  }, null, 512), [
                    [_vModelText, filters.description]
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('doubleEntries.entity_type')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.entityType) = $event)),
                    type: "text",
                    class: "form-control shadow-none fw-medium text-black fs-md-15",
                    placeholder: "payout"
                  }, null, 512), [
                    [_vModelText, filters.entityType]
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('doubleEntries.entity_code')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.entityCode) = $event)),
                    type: "text",
                    class: "form-control shadow-none fw-medium text-black fs-md-15"
                  }, null, 512), [
                    [_vModelText, filters.entityCode]
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('doubleEntries.entry_type')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.entryType) = $event)),
                    class: "form-select fs-md-15 text-black shadow-none"
                  }, [
                    _createElementVNode("option", _hoisted_72, _toDisplayString(_ctx.$t('doubleEntries.all')), 1),
                    _createElementVNode("option", _hoisted_73, _toDisplayString(_ctx.$t('doubleEntries.real')), 1),
                    _createElementVNode("option", _hoisted_74, _toDisplayString(_ctx.$t('doubleEntries.virtual')), 1)
                  ], 512), [
                    [_vModelSelect, filters.entryType]
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.$t('doubleEntries.currency')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.currency) = $event)),
                    type: "text",
                    class: "form-control shadow-none fw-medium text-black fs-md-15",
                    placeholder: "XOF"
                  }, null, 512), [
                    [_vModelText, filters.currency]
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('doubleEntries.date_from')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.dateFrom) = $event)),
                    type: "date",
                    class: "form-control shadow-none fw-medium text-black fs-md-15"
                  }, null, 512), [
                    [_vModelText, filters.dateFrom]
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t('doubleEntries.date_to')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.dateTo) = $event)),
                    type: "date",
                    class: "form-control shadow-none fw-medium text-black fs-md-15"
                  }, null, 512), [
                    [_vModelText, filters.dateTo]
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t('doubleEntries.exact_amount')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filters.amount) = $event)),
                    type: "number",
                    min: "0",
                    step: "any",
                    class: "form-control shadow-none fw-medium text-black fs-md-15"
                  }, null, 512), [
                    [_vModelText, filters.amount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t('doubleEntries.min_amount')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((filters.minAmount) = $event)),
                    type: "number",
                    min: "0",
                    step: "any",
                    class: "form-control shadow-none fw-medium text-black fs-md-15"
                  }, null, 512), [
                    [_vModelText, filters.minAmount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.$t('doubleEntries.max_amount')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((filters.maxAmount) = $event)),
                    type: "number",
                    min: "0",
                    step: "any",
                    class: "form-control shadow-none fw-medium text-black fs-md-15"
                  }, null, 512), [
                    [_vModelText, filters.maxAmount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.$t('doubleEntries.order')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((filters.ordre) = $event)),
                    class: "form-select fs-md-15 text-black shadow-none"
                  }, [
                    _createElementVNode("option", _hoisted_89, _toDisplayString(_ctx.$t('doubleEntries.order_desc')), 1),
                    _createElementVNode("option", _hoisted_90, _toDisplayString(_ctx.$t('doubleEntries.order_asc')), 1)
                  ], 512), [
                    [_vModelSelect, filters.ordre]
                  ])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t('doubleEntries.per_page')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((filters.count) = $event)),
                    class: "form-select fs-md-15 text-black shadow-none"
                  }, [...(_cache[31] || (_cache[31] = [
                    _createElementVNode("option", { value: 10 }, "10", -1),
                    _createElementVNode("option", { value: 20 }, "20", -1),
                    _createElementVNode("option", { value: 50 }, "50", -1),
                    _createElementVNode("option", { value: 100 }, "100", -1)
                  ]))], 512), [
                    [
                      _vModelSelect,
                      filters.count,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary me-auto",
                onClick: resetFilters
              }, _toDisplayString(_ctx.$t('doubleEntries.reset')), 1),
              _createElementVNode("button", _hoisted_94, _toDisplayString(_ctx.$t('doubleEntries.cancel')), 1),
              _createElementVNode("button", {
                type: "submit",
                disabled: tableLoading.value,
                class: "btn text-white",
                style: {"background-color":"#EB9355"}
              }, [
                _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$t('doubleEntries.apply')), 1)
              ], 8, _hoisted_95)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_97, [
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("h1", _hoisted_101, _toDisplayString(_ctx.$t('doubleEntries.detail_title')) + " (" + _toDisplayString(detail.value?.entryType?.toUpperCase() ?? '') + ")", 1),
            _cache[32] || (_cache[32] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          (!detailLoading.value && !detailError.value && detail.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["modal-tab", { active: activeDetailTab.value === 'main' }]),
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (activeDetailTab.value = 'main'))
                }, " Informations principales ", 2),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["modal-tab", { active: activeDetailTab.value === 'advanced' }]),
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (activeDetailTab.value = 'advanced'))
                }, " Informations avancées ", 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_103, [
            (detailLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.$t('doubleEntries.loading')), 1)
                  ])
                ]))
              : (detailError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                    _createElementVNode("p", _hoisted_108, _toDisplayString(_ctx.$t('doubleEntries.error_loading_detail')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary btn-sm",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (fetchDetail(currentDetailCode.value)))
                    }, _toDisplayString(_ctx.$t('doubleEntries.retry')), 1)
                  ]))
                : (detail.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_110, [
                          (hasValue(detail.value.code))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Code écriture", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((detail.value.code) = $event)),
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 512), [
                                  [_vModelText, detail.value.code]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.amount))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                _createElementVNode("label", _hoisted_113, _toDisplayString(_ctx.$t('doubleEntries.amount')), 1),
                                _createElementVNode("input", {
                                  value: `${formatAmount(detail.value.amount)} ${detail.value.currency}`,
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 8, _hoisted_114)
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.createdAt))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.$t('doubleEntries.date')), 1),
                                _createElementVNode("input", {
                                  value: formatDateTimeFr(detail.value.createdAt, true),
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 8, _hoisted_117)
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.currency))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t('doubleEntries.currency')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((detail.value.currency) = $event)),
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 512), [
                                  [_vModelText, detail.value.currency]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.entryType))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.$t('doubleEntries.entry_type')), 1),
                                _createElementVNode("input", {
                                  value: entryTypeLabel(detail.value.entryType),
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 8, _hoisted_122)
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.adjustmentType))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t('doubleEntries.status')), 1),
                                _createElementVNode("input", {
                                  value: adjustmentLabel(detail.value.adjustmentType),
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 8, _hoisted_125)
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.entity))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.$t('doubleEntries.entity')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((detail.value.entity) = $event)),
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 512), [
                                  [_vModelText, detail.value.entity]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.entityCode))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.$t('doubleEntries.entity_code')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((detail.value.entityCode) = $event)),
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 512), [
                                  [_vModelText, detail.value.entityCode]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.description))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                _createElementVNode("label", _hoisted_131, _toDisplayString(_ctx.$t('doubleEntries.description')), 1),
                                _createElementVNode("textarea", {
                                  value: detail.value.description,
                                  rows: "2",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 8, _hoisted_132)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("h6", _hoisted_133, _toDisplayString(_ctx.$t('doubleEntries.detail_ledger_entries')), 1),
                        _createElementVNode("div", _hoisted_134, [
                          _createElementVNode("table", _hoisted_135, [
                            _cache[37] || (_cache[37] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", { class: "ledger-col-side" }, "Débit"),
                                _createElementVNode("th", { class: "ledger-col-amount" }, "Montant"),
                                _createElementVNode("th", { class: "ledger-col-side" }, "Crédit"),
                                _createElementVNode("th", { class: "ledger-col-amount" }, "Montant")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ledgerTableRows.value, (row, idx) => {
                                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                  _createElementVNode("td", _hoisted_136, [
                                    _createElementVNode("div", _hoisted_137, _toDisplayString(row.debitAccount), 1),
                                    (row.debitCode)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                          _createElementVNode("span", _hoisted_139, _toDisplayString(row.debitCode), 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "copy-btn-mini",
                                            onClick: ($event: any) => (copyText(row.debitCode))
                                          }, "Copier", 8, _hoisted_140)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_141, [
                                    _createElementVNode("span", _hoisted_142, _toDisplayString(formatAmount(row.debitAmount)), 1),
                                    _createElementVNode("span", _hoisted_143, _toDisplayString(row.currency), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_144, [
                                    _createElementVNode("div", _hoisted_145, _toDisplayString(row.creditAccount), 1),
                                    (row.creditCode)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                          _createElementVNode("span", _hoisted_147, _toDisplayString(row.creditCode), 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "copy-btn-mini",
                                            onClick: ($event: any) => (copyText(row.creditCode))
                                          }, "Copier", 8, _hoisted_148)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_149, [
                                    _createElementVNode("span", _hoisted_150, _toDisplayString(formatAmount(row.creditAmount)), 1),
                                    _createElementVNode("span", _hoisted_151, _toDisplayString(row.currency), 1)
                                  ])
                                ]))
                              }), 128)),
                              (!ledgerTableRows.value.length)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_152, [...(_cache[34] || (_cache[34] = [
                                    _createElementVNode("td", {
                                      colspan: "4",
                                      class: "text-center text-body-tertiary py-15"
                                    }, "—", -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ]),
                            (ledgerTableRows.value.length)
                              ? (_openBlock(), _createElementBlock("tfoot", _hoisted_153, [
                                  _createElementVNode("tr", null, [
                                    _cache[35] || (_cache[35] = _createElementVNode("td", { class: "ledger-total-label" }, "Total débit", -1)),
                                    _createElementVNode("td", _hoisted_154, [
                                      _createElementVNode("span", _hoisted_155, _toDisplayString(formatAmount(totalDebit.value)), 1),
                                      _createElementVNode("span", _hoisted_156, _toDisplayString(detail.value.currency), 1)
                                    ]),
                                    _cache[36] || (_cache[36] = _createElementVNode("td", { class: "ledger-total-label" }, "Total crédit", -1)),
                                    _createElementVNode("td", _hoisted_157, [
                                      _createElementVNode("span", _hoisted_158, _toDisplayString(formatAmount(totalCredit.value)), 1),
                                      _createElementVNode("span", _hoisted_159, _toDisplayString(detail.value.currency), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 512), [
                        [_vShow, activeDetailTab.value === 'main']
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        (transactionFields.value.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("h6", _hoisted_160, _toDisplayString(_ctx.$t('doubleEntries.detail_transaction')), 1),
                              _createElementVNode("div", _hoisted_161, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactionFields.value, (field) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: field.key,
                                    class: "col-12 col-md-3"
                                  }, [
                                    _createElementVNode("label", _hoisted_162, _toDisplayString(field.label), 1),
                                    _createElementVNode("input", {
                                      value: field.value,
                                      type: "text",
                                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                      readonly: ""
                                    }, null, 8, _hoisted_163)
                                  ]))
                                }), 128))
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        (topupFields.value.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("h6", _hoisted_164, _toDisplayString(_ctx.$t('doubleEntries.detail_topup')), 1),
                              _createElementVNode("div", _hoisted_165, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topupFields.value, (field) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: field.key,
                                    class: "col-12 col-md-3"
                                  }, [
                                    _createElementVNode("label", _hoisted_166, _toDisplayString(field.label), 1),
                                    _createElementVNode("input", {
                                      value: field.value,
                                      type: "text",
                                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                      readonly: ""
                                    }, null, 8, _hoisted_167)
                                  ]))
                                }), 128))
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        (repaymentFields.value.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("h6", _hoisted_168, _toDisplayString(_ctx.$t('doubleEntries.detail_repayment')), 1),
                              _createElementVNode("div", _hoisted_169, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repaymentFields.value, (field) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: field.key,
                                    class: "col-12 col-md-3"
                                  }, [
                                    _createElementVNode("label", _hoisted_170, _toDisplayString(field.label), 1),
                                    _createElementVNode("input", {
                                      value: field.value,
                                      type: "text",
                                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                      readonly: ""
                                    }, null, 8, _hoisted_171)
                                  ]))
                                }), 128))
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("h6", _hoisted_172, _toDisplayString(_ctx.$t('doubleEntries.detail_integrity')), 1),
                        _createElementVNode("div", _hoisted_173, [
                          (hasValue(detail.value.integrityHash))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                _createElementVNode("label", _hoisted_175, _toDisplayString(_ctx.$t('doubleEntries.integrity_hash')), 1),
                                _createElementVNode("input", {
                                  value: detail.value.integrityHash,
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 8, _hoisted_176)
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.previousHash))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                                _createElementVNode("label", _hoisted_178, _toDisplayString(_ctx.$t('doubleEntries.previous_hash')), 1),
                                _createElementVNode("input", {
                                  value: detail.value.previousHash,
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 8, _hoisted_179)
                              ]))
                            : _createCommentVNode("", true),
                          (hasValue(detail.value.externalReference))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                _createElementVNode("label", _hoisted_181, _toDisplayString(_ctx.$t('doubleEntries.external_reference')), 1),
                                _createElementVNode("input", {
                                  value: detail.value.externalReference,
                                  type: "text",
                                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                  readonly: ""
                                }, null, 8, _hoisted_182)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 512), [
                        [_vShow, activeDetailTab.value === 'advanced']
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _cache[38] || (_cache[38] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})